// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    suggestionMode: 'test',
    //suggestionPosition: 'left'
    suggestionMobileStyle: 'style1',
    reduceMinMatch: true,
    enablePlusCharacterSearch: true
  }
};

(function () {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);
  
  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};

  /*InstantSearchApi.beforeCall = function(searchTerm) {
      
      var searchTermArr = searchTerm.split('');
      var counter = 0;
      var newStr = '';
      for(var i = 0; i < searchTermArr.length; i++){
        counter++;
        newStr += searchTermArr[i];
        if(counter == 4){
          newStr += ' ';
          counter = 0;
        }
      }
      Globals.instantSearchQueryParams['q'] = newStr;
  } */

  jQ('input[name="q"]').on("keyup",function(e){
    if(e.key==="Enter"||e.keyCode===13){
      var t = jQ('input[name="q"]').val();
      location.href="/search?q="+t
    }
  });

   // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop, .header-item--icons .js-search-header';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input, .site-header__search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a, .js-search-header-close';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
})();